import { type OperationResponse, type Parameters } from "../../common.ts";
import { omitPathParameters, replacePathParameters } from "../../utils";
import type { AxiosInstance, AxiosRequestConfig } from "axios";
import type * as Paths from "./paths";

export interface OperationMethods {
  "getVariantsForComponentList"(
    parameters: Parameters<
      Paths.GetVariantsForComponentList.QueryParameters &
        Paths.GetVariantsForComponentList.PathParameters
    >,
    data?: null,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.GetVariantsForComponentList.Responses.$200>;

  "manageVariantsComponentList"(
    parameters: Parameters<
      Paths.ManageVariantsComponentList.QueryParameters &
        Paths.ManageVariantsComponentList.PathParameters
    >,
    data: Paths.ManageVariantsComponentList.RequestBody,
    config?: AxiosRequestConfig,
  ): OperationResponse<Paths.ManageVariantsComponentList.Responses.$200>;
}

export const getVariantOperations = (client: AxiosInstance) => {
  const getVariantsForComponentList: OperationMethods["getVariantsForComponentList"] =
    (parameters, _, config) => {
      const url = "/variant/{id}/components";
      return client.get(replacePathParameters(url, parameters), {
        params: omitPathParameters(parameters, url),
        ...config,
      });
    };

  const manageVariantsComponentList: OperationMethods["manageVariantsComponentList"] =
    (parameters, data, config) => {
      const url = "/variant/{id}/components";
      return client.post(replacePathParameters(url, parameters), data, {
        params: omitPathParameters(parameters, url),
        ...config,
      });
    };

  return {
    getVariantsForComponentList,
    manageVariantsComponentList,
  };
};
